/**
 * Created by lency on 9/22/2016.
 */
class ClipboardService {
    constructor(message,$filter, $timeout) {
        "ngInject";
        this.tranlsteFilter=$filter('translate');
        this.message = message;
        this.$timeout = $timeout;
    }

    copyElementById(id) {
        var node = document.getElementById(id);
        this.selectContent(node);

        if (!document.execCommand('copy')) {
            this.$timeout(() => {
                this.message.error(this.tranlsteFilter('services-text001'));
            }, 300);
        } else {
            this.$timeout(() => {
                this.message.success('<i class="fa fa-check-circle"></i> '+this.tranlsteFilter('services-text002'));
            }, 300);
        }
    }

    selectContent(node) {
        var range, selection;

        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(node);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}

export default ClipboardService



// WEBPACK FOOTER //
// ./src/app/services/clipboard.service.js